import * as React from "react";
import { Checkbox as BootstrapCheckbox } from "react-bootstrap";
import { useEffect, useImperativeHandle, useRef } from "react";
const Checkbox = ({ onChange, indeterminate = false, ...props }, forwardedRef) => {
  const checkboxRef = useRef(null);
  useImperativeHandle(forwardedRef, () => checkboxRef.current);
  useEffect(() => {
    if (checkboxRef.current && checkboxRef.current.indeterminate !== indeterminate) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [checkboxRef, indeterminate]);
  return /* @__PURE__ */ React.createElement(
    BootstrapCheckbox,
    {
      onChange,
      inputRef: (ref) => {
        checkboxRef.current = ref;
      },
      ...props
    }
  );
};
export default React.forwardRef(Checkbox);
